import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  SimpleGrid,
  Table,
} from '../../../components/index';
import {
  getObject,
} from '../../../utils/listsSelect';
import { trataMensagensErro } from '../../../utils/requests';
import { tamanhoMaximoArquivoUpload } from '../../../utils/constants';
import ModalUploadArquivosMsg from '../../../pages/controle-pagamento/templates/ModalUploadDocumentoMsg';

class UploadArquivosMsg extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    acaoModal: 'criacao',
    showModal: false,
    showDocumentUploadModal: false,
    apagouArquivo: false,
    desabilitado: false,
  })

  showDocumentUploadModal = () => {
    this.setState({ showDocumentUploadModal: !this.state.showDocumentUploadModal });
  }

  createCustomInsertButton = () => (
    <Button
      disabled={this.state.desabilitado}
      onClick={() => this.showDocumentUploadModal()}
      hint="Carregar Arquivo"
      icon="ico-upload"
    />
  );

  /**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   */
  createActionColumn = indice => (
    <React.Fragment>
      <Button
        className="dtp-inverse"
        hint="Excluir arquivo"
        icon="ico-doc-minus"
        mini
        onClick={() => this.deleteArquivo(indice)}
      />
    </React.Fragment>
  );

  addSituacaoLabel = (tipoDocumento) => {
    const obj = getObject(this.props.tiposDocumentos, tipoDocumento);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
    // const obj = getObject(situacao, situacaoSelecionado);
    // return obj.label;
  }
  /**
   * Determina quais colunas devem ser exibidas na tabela de arquivos
   */
  montaArquivosTableHeader = () => {
    const tableHeader = [
      {
        id: 'legenda',
        label: 'Legenda',
      },
      {
        id: 'nome',
        label: 'Arquivo',
      },
    ];
    tableHeader.push({
      id: 'acoes',
      label: 'Ação',
      dataFormat: this.createActionColumn,
    });
    return tableHeader;
  }

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum arquivo foi adicionado à lista',
    sizePerPage: 5,
  };

  /**
   * Altera um dependente da lista
   */
   editArquivo = (indice, arquivoSelecionado) => {
     this.setState({
       cell: indice,
       arquivoSelecionado,
     });
   }

  /**
   * Exclui um arquivo da lista
   */
  deleteArquivo = (row) => {
    const { arquivos } = { ...this.props };
    arquivos.splice(row, 1);
    this.alteraListaArquivos(arquivos);
  }

  alteraListaArquivos = (listaArquivos) => {
    this.props.handleChange({ value: listaArquivos, isValid: listaArquivos.length > 0 });
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }
  /**
   * Adiciona arquivo a lista
   */
  addArquivo = (arquivo) => {
    if (arquivo) {
      const { arquivos } = { ...this.props };
      const tamanhoDocumentoUpload = arquivo.size;

      let arquivoValido = arquivo.type === 'application/pdf';
      arquivoValido = arquivoValido && (tamanhoDocumentoUpload <= tamanhoMaximoArquivoUpload);

      if (arquivoValido) {
        arquivos.push(arquivo);
      } else {
        trataMensagensErro([`Certifique-se de que o documento ${arquivo.name} é um PDF e possui tamanho inferior a 3 mb.`]);
      }

      this.alteraListaArquivos(arquivos, null);
      this.setState(this.handleModal('showDocumentUploadModal'));
    }
  }

  handleResponseUploadDocumento = (response) => {
    this.setState(
      {
        requerimentoModalDocumento: response.data,
      },
      () => this.handleModal('showDocumentUploadModal'),
    );
  }

  handleErrorEncerramentoExigencia = () => {}

  render() {
    const listaArquivosIndexada = this.props.arquivos.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      itemIndexado.nome = itemIndexado.name;
      return itemIndexado;
    });
    return (
      <SimpleGrid title="Upload de Arquivos" icon="ico-doc-list" >
        <Table
          bordered
          data={listaArquivosIndexada}
          insertRow
          options={this.options}
          listaTableHeader={this.montaArquivosTableHeader()}
          pagination
          fetchInfo={this.fetchInfo}
        />
        { this.state.showDocumentUploadModal ? (
          <ModalUploadArquivosMsg
            {...this.props}
            infoPagamento={this.props.infoPagamento}
            handleModal={() => this.handleModal('showDocumentUploadModal')}
            showModal={this.state.showDocumentUploadModal}
            addArquivo={this.addArquivo}
          />
        ) : ''}
      </SimpleGrid>
    );
  }
}

UploadArquivosMsg.propTypes = {
  arquivos: PropTypes.arrayOf({
    legenda: PropTypes.string,
    nome: PropTypes.string,
  }).isRequired,
  estadoFormulario: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default UploadArquivosMsg;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/UploadArquivosMsg.jsx